import { useEffect } from 'react'

interface UseRegisterTitleParams {
  id: string | undefined
  rendered: boolean
  registerTitle: ((id: string) => () => void) | undefined
}

/** Registers a rendered title as its surface's accessible name for as long as it stays rendered. */
export const useRegisterTitle = ({ id, rendered, registerTitle }: UseRegisterTitleParams) => {
  useEffect(() => {
    if (!rendered || id == null || registerTitle == null) {
      return
    }

    return registerTitle(id)
  }, [id, rendered, registerTitle])
}
